import vars from './vars.json';
const getCssVars = () => vars;
export default getCssVars;
//# sourceMappingURL=getCssVars.js.map